var map = {
	"./1.svg": 5155,
	"./1ocjena.svg": 1909,
	"./2.svg": 5760,
	"./2ocjena.svg": 2114,
	"./3.svg": 6881,
	"./3ocjena.svg": 6723,
	"./4ocjena.svg": 8384,
	"./5ocjena.svg": 985,
	"./img/bell.svg": 2157,
	"./img/cd-icon-filter.svg": 8234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;